import React, { useContext } from 'react'
import BuyNowBar from './BuyNowBar'
import AuctionContractBar from './AuctionContractBar'
import { ItemContext } from 'src/contexts/itemContext'
import ThankYouBar from './ThankYouBar'
import ThankYouAuctionSvg from 'src/components/other/svg/ThankYouAuction'
import { t } from 'i18next'
import ThankYouBuyNowSvg from 'src/components/other/svg/ThankYouBuyNowSvg'
import PickUpBar from './PickUpBar'
import TransportBar from './TransportBar'
import { useLocation } from 'react-router-dom'

interface Props {
  buyNowPrice?: number
  highestBet?: number
  offerId: number
  currentDealerHighestBet?: number
}

const ActionBar = ({ offerId, buyNowPrice = 0, highestBet }: Props): JSX.Element => {
  const itemContext = useContext(ItemContext)
  if (itemContext === null) {
    throw new Error('itemContext must be used within a ItemProvider')
  }
  const { pathname } = useLocation()

  if (itemContext.bar === 'buy_now') {
    return <BuyNowBar buyNowPrice={buyNowPrice ?? 0} offerId={offerId} />
  }
  if (itemContext.bar === 'auction_contract') {
    return <AuctionContractBar offerId={offerId} highestBet={highestBet ?? 0} />
  }
  if (itemContext.bar === 'pick_up') {
    return <PickUpBar offerId={offerId} />
  }
  if (itemContext.bar === 'transport') {
    return <TransportBar offerId={offerId} />
  }
  if (itemContext.bar === 'thank_you_transport') {
    return (
      <ThankYouBar
        iconComponent={<ThankYouAuctionSvg className="w-[84px] h-[78px] text-white" />}
        message={t('in_realization_list_item.transport_arranged_long')}
        color="bg-darkBlue"
        barAfterClose="thank_you_transport"
      />
    )
  }
  if (itemContext.bar === 'thank_you_pick_up') {
    return (
      <ThankYouBar
        iconComponent={<ThankYouAuctionSvg className="w-[84px] h-[78px] text-white" />}
        message={t('in_realization_list_item.confirm_pick_up')}
        color="bg-darkBlue"
        barAfterClose="thank_you_pick_up"
      />
    )
  }
  if (itemContext.bar === 'thank_you_auction_contract') {
    return (
      <ThankYouBar
        iconComponent={<ThankYouAuctionSvg className="w-[84px] h-[78px] text-white" />}
        message={t('auction_contract_modal.your_offer_has_been_sent')}
        color="bg-yellow"
        barAfterClose={buyNowPrice > 0 ? 'buy_now' : 'auction_contract'}
        redirectType={pathname === '/purchasing/my-bets' ? 'no_redirect' : 'redirect_my_bets'}
      />
    )
  }
  if (itemContext.bar === 'thank_you_buy_now') {
    return (
      <ThankYouBar
        iconComponent={<ThankYouBuyNowSvg className="w-[84px] h-[78px]  text-white" />}
        message={t('buy_now_modal.you_offer_has_been_sent')}
        color="bg-successGreen"
        barAfterClose={buyNowPrice > 0 ? 'buy_now' : 'auction_contract'}
        redirectType="redirect_realization"
      />
    )
  }
  return <AuctionContractBar offerId={offerId} highestBet={highestBet ?? 0} />
}

export default ActionBar
